import React from 'react'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined'
import KeycloakService from '../utils/keycloakService'
import { ADMIN_EXPORT_DATA } from '../utils/roles'
import { exportExcel } from '../utils/hooks/Utils'
import { toast } from 'react-toastify'
import useCustomStyles from '../utils/hooks/CustomStylesHook'

interface ExportButtonProps {
  data: any
  disabled?: boolean
  icon?: boolean
}
const styles = () => ({
  MedAgDataGridExportIcon: {
    background: '#4682b4',
    color: '#ffffff',
    borderRadius: 5,
  },
  disabledBtn: {
    background: 'grey',
    cursor: 'none',
  },
  iconButton: {
    padding: 'unset',
  },
})

const ExportButton: React.FC<ExportButtonProps> = ({
  data,
  disabled,
  icon,
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  if (!KeycloakService?.hasRole([ADMIN_EXPORT_DATA])) return null
  const handleExport = () => {
    if (data?.length > 0) {
      exportExcel(data)
    } else {
      toast?.error('No Data Found')
    }
  }
  return (
    <IconButton
      onClick={handleExport}
      disabled={disabled}
      className={`${icon ? classes?.iconButton : ''}`}
    >
      <Tooltip title='Export'>
        <GetAppOutlinedIcon
          className={
            disabled ? classes?.disabledBtn : classes?.MedAgDataGridExportIcon
          }
        />
      </Tooltip>
    </IconButton>
  )
}

export default ExportButton
